<template>
  <div class="notification-box">
    <div v-for="item in news"
         class="notification-card" :class="classType(item)">
      <span @click="close(item.id)" v-if="item.hasClose" class="close-btn">
        <icon name="close" />
      </span>
      <div class="card-title">{{item.title}}</div>

      <div class="card-p">{{item.msg}}</div>
      <div>
        <b-link v-for="action in item.actions"
                :key="action.text"
                @click="doAction(action, item.id)">
          {{action.text}}
        </b-link>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import notification from './notification.js'

  export default {
    props: {
    },
    data () {
      return {
        news: notification.news
      }
    },
    computed: {
    },
    methods: {
      classType (item) {
        let key = item.type || 'info'
        return {
          [key]: true
        }
      },
      close (id) {
        this.news.splice(_.findIndex(this.news, item => {
          return item.id === id
        }), 1)
      },
      doAction (action, id) {
        if (action.hasOwnProperty('fun')) {
          action.fun()
        }
        if (action.close === true) {
          notification.close(id)
        }
      }
    },
    created () {
      // notification.notice('info', 'It may take some time, please wait', {
      //   title: 'Counting',
      //   duration: 0,
      //   actions: [{
      //     text: 'close',
      //     close: true
      //   }]
      // })
      // TODO@PONY expample need to delete
      // this.$notice('networkError')
      // this.$notice('error', 'Network connection failed', {
      //   title: 'Error',
      //   duration: 0,
      //   hasClose: true,
      //   actions: [
      //     {
      //       text: 'refresh',
      //       fun () {
      //         alert('ok')
      //       }
      //     }
      //   ]
      // })
    }
  }
</script>
<style scoped lang="scss">
  .notification-box {
    position: fixed;
    z-index: 10000;
    top: 20px;
    right: 20px;
    background-color: transparent;
    overflow: visible;
  }
  .notification-card {
    width: 300px;
    color: #fff;
    //color: #721c24;
    position: relative;
    background-color: #000;
    box-shadow: #999 0 0 12px;
    padding: 8px;
    padding-right: 24px;
    opacity: 0.9;
    margin:0 0 6px 0;
  }
  .notification-card.success {
    background-color: green;
  }
  .notification-card.error {
    background-color: #f8d7da;
    //background-color: #721c24;
    color: #721c24 !important;
  }
  .notification-card.info {
    background-color: $color-primary;
  }
  .notification-card.warning {
    background-color: #ff9e44;
  }
  .card-title {
    //color: #fff;
    font-size: 1rem;
  }
  .card-p {
    //color: #fff;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }
  .close-btn {
    position: absolute;
    top: 16px;
    right: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/MNotification.vue